import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { FooterCTA } from '../components/FooterCTA';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-slate-50 font-sans selection:bg-brand-green selection:text-white" data-id="element-102">
      <HeroSection data-id="element-103" />
      <BenefitsSection data-id="element-104" />
      <TestimonialsSection data-id="element-105" />
      <PricingSection data-id="element-106" />
      <FooterCTA data-id="element-107" />
    </main>;
}